import moment from 'moment';
import { AURA_ONLY_APPOINTMENT_TYPE } from './constants';

/**
 * Computes the absolute { startDate, endDate } for a given relative date filter
 * label. Both dates are formatted as 'YYYY-MM-DD'.
 *
 * Returns null for 'All time', 'Custom', or unknown values so callers can
 * handle those cases themselves.
 */
export const getDateRangeForFilter = (datefilter) => {
  const today = moment().format('YYYY-MM-DD');
  switch (datefilter) {
    case 'Today':
      return { startDate: today, endDate: today };
    case 'Yesterday': {
      const d = moment().subtract(1, 'days').format('YYYY-MM-DD');
      return { startDate: d, endDate: d };
    }
    case 'Tomorrow': {
      const d = moment().add(1, 'days').format('YYYY-MM-DD');
      return { startDate: d, endDate: d };
    }
    case 'Past 7 days':
      return {
        startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
        endDate: today,
      };
    case 'Next 7 days':
      return {
        startDate: today,
        endDate: moment().add(6, 'days').format('YYYY-MM-DD'),
      };
    default:
      return null;
  }
};

export const getAppointmentAllStartDateFilter = (startDate) => {
  return startDate
    ? startDate
    : startDate === ''
      ? ''
      : moment().subtract(10, 'years').format('YYYY-MM-DD');
};

export const getAppointmentAllEndDateFilter = (endDate) => {
  return endDate
    ? endDate
    : endDate === ''
      ? ''
      : moment().add(10, 'years').format('YYYY-MM-DD');
};

export const isAuraOnlyAppointmentType = (
  appointmentTypeId,
  appointmentTypes = []
) => {
  let isAuraOnlyAppointment = false;

  for (let index = 0; index < appointmentTypes.length; index++) {
    if (
      appointmentTypes[index].label === AURA_ONLY_APPOINTMENT_TYPE &&
      appointmentTypes[index].value === appointmentTypeId
    ) {
      isAuraOnlyAppointment = true;
      break;
    }
  }

  return isAuraOnlyAppointment;
};
